import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useEffect, useRef, useState } from 'react';
import { getInputValue, setInputValue } from '../../util/refUtils';
import { Toast } from 'primereact/toast';
import { crearDuenoSiniestro, eliminarDuenoSiniestro, modificarDuenoSiniestro } from '../../services/Siniestro/SiniestroService';
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import AsignaZonas from './AsignaZonas';

const NuevoCliente = ({ funcSalir, datCliente }) => {
    //console.log('HHH DATOS CLIENTE', datCliente);
    const [grabando, setGrabando] = useState(false);
    const [eliminando, setEliminando] = useState(false);
    const [confEliminar, setConfEliminar] = useState(false);

    const [visibleAsigna, setVisibleAsigna] = useState(false);

    const refNombreCli = useRef('');
    const toastNeoCli = useRef();

    useEffect(() => {
        const inicial = () => {
            if (datCliente?.nombre) {
                //console.log('entra aqui')
                setInputValue(refNombreCli, datCliente?.nombre);
            }
        };
        inicial();
    }, [datCliente]);

    const handleGuardar = async () => {
        const nombreVal = getInputValue(refNombreCli);
        if (!nombreVal) {
            toastNeoCli.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe llenar el campo Nombre.'
            });
            return;
        }
        try {
            setGrabando(true);
            const CODE_CONFIGCAB_CLIENTE = 'SIN-0000-0002';
            const objCrear = {
                configuracionCabId: 0,
                codigo: 'nuevo',
                nombre: nombreVal
            };
            let datos;
            if (datCliente?.configuracionDetId) {
                objCrear['configuracionDetId'] = datCliente?.configuracionDetId;
                //console.log('JJJJ MODIFICAR...: ', objCrear)
                datos = await modificarDuenoSiniestro(objCrear, CODE_CONFIGCAB_CLIENTE);
            } else {
                datos = await crearDuenoSiniestro(objCrear, CODE_CONFIGCAB_CLIENTE);
            }
            //console.log ('DEVUELTO...:', datos)
            if (datos?.configuracionDetId) {
                toastNeoCli.current.show({
                    severity: 'success',
                    summary: 'Exito',
                    detail: 'Se ha registrado el Cliente.'
                });
            }
        } catch (error) {
            console.error('ERROR: No se ha podido guardar Cliente');
            toastNeoCli.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al registrar el Cliente.'
            });
        } finally {
            setGrabando(false);
            funcSalir();
        }
    };

    const mostrarAsigna = () => {
        setVisibleAsigna(true);
    };

    const ocultaAsigna = () => {
        setVisibleAsigna(false);
    }

    const pedirEliminar = () => {
        setConfEliminar(true);
    };

    const confirmarEliminar = async () => {
        if (!datCliente?.configuracionDetId) return;
        try {
            setEliminando(true);
            await eliminarDuenoSiniestro(datCliente.configuracionDetId);
            toastNeoCli.current.show({
                severity: 'success',
                summary: 'Exito',
                detail: 'Cliente eliminado.'
            });
            setConfEliminar(false);
            funcSalir();
        } catch (error) {
            console.error('ERROR: Error al eliminar el Cliente');
            toastNeoCli.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el Cliente.'
            });
        } finally {
            setEliminando(false);
        }
    };

    return (
        <div className="card">
            <Toast ref={toastNeoCli} />
            <Dialog visible={visibleAsigna} onHide={() => setVisibleAsigna(false)} header='Asignar Zonas' >
                <AsignaZonas datCliente={datCliente} funcSalir={ocultaAsigna} />
            </Dialog>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-12">
                    <label>Nombre del Cliente</label>
                    <InputText
                        ref={refNombreCli}
                        defaultValue=""
                        onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
                        maxLength={100}
                    />
                </div>
                <div className="field col-12 md:col-3">
                    <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                </div>
                <div className="field col-12 md:col-3">
                    <Button
                        label="Asignar Zonas"
                        icon="pi pi-link"
                        className="p-button-primary"
                        disabled={!datCliente?.nombre}
                        onClick={mostrarAsigna}
                    />
                </div>
                <div className="field col-12 md:col-3">
                    <Button
                        label="Eliminar"
                        className="p-button-danger"
                        icon="pi pi-trash"
                        disabled={!datCliente?.configuracionDetId}
                        onClick={pedirEliminar}
                        loading={eliminando}
                    />
                </div>
                <div className="field col-12 md:col-3">
                    <Button
                        label="Guardar"
                        className="p-button-primary"
                        icon="pi pi-save"
                        onClick={handleGuardar}
                        loading={grabando}
                    />
                </div>
            </div>
            <ConfirmDialog
                visible={confEliminar}
                onHide={() => setConfEliminar(false)}
                message={`¿Confirma eliminar el cliente "${datCliente?.nombre}"?`}
                header="Eliminar Cliente"
                icon="pi pi-exclamation-triangle"
                acceptLabel="Si"
                rejectLabel="No"
                acceptClassName="p-button-danger"
                accept={confirmarEliminar}
            />
        </div>
    );
};

export default NuevoCliente;
